import { Inject, Injectable } from '@angular/core';
import { HttpUtil } from '@shared/util/http.util';
import { Observable } from 'rxjs';
import { TokenDTO } from '@data/auth/TokenDTO';
import { ApplicationConfig } from '@config/application.config';
import { AuthProvider } from '@data/auth/AuthProvider';
import { AUTH_PROVIDER } from '@shared/common/injector-token';
import { StartRegistrationDTO } from '@data/auth/StartRegistrationDTO';
import { CompleteRegistrationDTO } from '@data/auth/CompleteRegistrationDTO';
import { FillAccountDataDTO } from '@data/auth/FillAccountDataDTO';

@Injectable({
  providedIn: 'root'
})
export class AccountApiService {
  constructor(private httpUtil: HttpUtil,
              @Inject(AUTH_PROVIDER) private authProvider: AuthProvider) {
  }

  public startRegistration(payload: StartRegistrationDTO): Observable<void> {
    return this.httpUtil.post(`${ ApplicationConfig.apiUrl }/accounts`, payload);
  }

  public completeRegistration(payload: CompleteRegistrationDTO): Observable<void> {
    return this.httpUtil.post(`${ ApplicationConfig.apiUrl }/accounts/confirm`, payload);
  }

  public resendConfirmation(email: string): Observable<void> {
    return this.httpUtil.post(`${ ApplicationConfig.apiUrl }/accounts:resend-confirmation`, {  email  });
  }

  public fillProfileData(payload: FillAccountDataDTO): Observable<void> {
    return this.httpUtil.post(`${ ApplicationConfig.apiUrl }/patients/me/personal-data`, payload);
  }
}
